import { render, staticRenderFns } from "./DrawerList.vue?vue&type=template&id=15d72912"
import script from "./DrawerList.vue?vue&type=script&lang=ts"
export * from "./DrawerList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports